import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import VueCookies from 'vue-cookies'
import Axios from './axios'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import Auth from "./plugins/auth/auth";
import Helper from "./plugins/helpers/helpers";
import VueApexCharts from 'vue-apexcharts'
import money from 'v-money'
import VueSimpleAccordion from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import Notifications from 'vue-notification'

import "mdi-icons/css/materialdesignicons.min.css";

Vue.use(VueSimpleAccordion, {});
Vue.use(money, {
    decimal: '.',
    thousands: ',',
    prefix: '',
    suffix: '',
    precision: null,
    masked: false
})
Vue.prototype.$axios = Axios

Vue.use(VueCookies)
Vue.use(Auth);
Vue.use(Helper);

Vue.use(VueApexCharts)
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.component('apexchart', VueApexCharts)
Vue.use(Notifications)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')